


















import { Component, Prop, Vue } from 'vue-property-decorator'
import GlpUI from '@@/index'
import Asider from './asider/index.vue'

const version = GlpUI.version
@Component({
  components: { Asider }
})
export default class Layout extends Vue {
  version = version

  get activeIndex () {
    return this.$route.path.startsWith('/changelog') ? '/changelog' : '/'
  }
}
